<template>
   <div
        class="flex items-center gap-2 text-sm text-black/70"
        data-testid="pdp-loading-container"
      >
        <img
          :src="smartSearchLoading"
          alt="Loading"
          class="w-[58px] h-[28px]"
          data-testid="pdp-loading-icon"
        />
        Generating details...
      </div>
</template>

<script setup lang="ts">
import smartSearchLoading from "~/assets/tgpt/images/smartSearchLoading.svg"
</script>
